"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWellFormedGenericType = exports.isWellFormedDataRepType = exports.isWellFormedType = exports.isGenericStructType = exports.isStructType = exports.isSopType = exports.isGenericStructDefinition = exports.isStructDefinition = exports.isSopDefinition = void 0;
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var isPrimTypeTag_1 = require("./isPrimTypeTag.js");
var isTaggedAsAlias_1 = require("./isTaggedAsAlias.js");
var isTypePAram_1 = require("./isTypePAram.js");
var types_1 = require("../types.js");
var utils_1 = require("../utils.js");
var tyArgs_1 = require("../tyArgs/index.js");
function getIsStructDefWithTermTypeCheck(termTypeCheck) {
    return function (def) {
        if (!(0, obj_utils_1.isObject)(def))
            return false;
        var ctorsNames = Object.keys(def);
        // required at least one constructor
        if (ctorsNames.length <= 0)
            return false;
        if (!ctorsNames.every(
        // all constructor names
        function (ctorName) {
            // cannot be empty
            return ctorName.length > 0 &&
                // no white spaces
                ctorName.replace(/\s/g, '') === ctorName &&
                // cannot start with a number
                Number.isNaN(parseFloat(ctorName[0]));
        }))
            return false;
        var _loop_1 = function (i) {
            var thisCtorFields = def[ctorsNames[i]];
            var thisCtorFieldsNames = Object.keys(thisCtorFields);
            if (!thisCtorFieldsNames.every(function (field) {
                return termTypeCheck(thisCtorFields[field]);
            }))
                return { value: false };
        };
        for (var i = 0; i < ctorsNames.length; i++) {
            var state_1 = _loop_1(i);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return true;
    };
}
exports.isSopDefinition = getIsStructDefWithTermTypeCheck(isWellFormedType);
exports.isStructDefinition = getIsStructDefWithTermTypeCheck(isWellFormedDataRepType);
exports.isGenericStructDefinition = getIsStructDefWithTermTypeCheck(isWellFormedGenericType);
function isSopType(t) {
    return (Array.isArray(t) &&
        t.length >= 2 &&
        t[0] === types_1.PrimType.Sop &&
        (0, exports.isSopDefinition)(t[1]));
}
exports.isSopType = isSopType;
function isStructType(t) {
    return (Array.isArray(t) &&
        t.length >= 2 &&
        t[0] === types_1.PrimType.Struct &&
        (0, exports.isStructDefinition)(t[1]));
}
exports.isStructType = isStructType;
function isGenericStructType(t) {
    return (Array.isArray(t) &&
        t.length >= 2 &&
        t[0] === types_1.PrimType.Struct &&
        (0, exports.isGenericStructDefinition)(t[1]));
}
exports.isGenericStructType = isGenericStructType;
function isWellFormedType(t) {
    if ((0, isTaggedAsAlias_1.isTaggedAsAlias)(t))
        return isWellFormedType(t[1]);
    if (!(Array.isArray(t) &&
        t.length > 0))
        return false;
    if ((0, isTypePAram_1.isTypeParam)(t))
        return false;
    var primTypeTag = t[0];
    if (!((0, isPrimTypeTag_1.isPrimTypeTag)(primTypeTag)))
        return false;
    // just base type
    if (t.length === 1)
        return (0, isPrimTypeTag_1.isBasePrimType)(primTypeTag);
    if (primTypeTag === types_1.PrimType.Delayed ||
        primTypeTag === types_1.PrimType.AsData ||
        primTypeTag === types_1.PrimType.List ||
        // ??
        primTypeTag === types_1.PrimType.Alias)
        return t.length >= 2 && isWellFormedType(t[1]);
    if (primTypeTag === types_1.PrimType.Struct) {
        return t.length >= 2 && (0, exports.isStructDefinition)(t[1]);
    }
    if (primTypeTag === types_1.PrimType.Sop) {
        return t.length >= 2 && (0, exports.isSopDefinition)(t[1]);
    }
    if (primTypeTag === types_1.PrimType.Lambda ||
        primTypeTag === types_1.PrimType.Pair)
        return (t.length === 3 &&
            isWellFormedType(t[1]) &&
            isWellFormedType(t[2]));
    return false;
}
exports.isWellFormedType = isWellFormedType;
function isWellFormedDataRepType(t) {
    if ((0, isTaggedAsAlias_1.isTaggedAsAlias)(t))
        return isWellFormedDataRepType(t[1]);
    if (!(Array.isArray(t) &&
        t.length > 0))
        return false;
    if ((0, isTypePAram_1.isTypeParam)(t))
        return false;
    var primTypeTag = t[0];
    if (!((0, isPrimTypeTag_1.isPrimTypeTag)(primTypeTag)))
        return false;
    // just base type
    if (t.length === 1)
        return (0, isPrimTypeTag_1.isBaseDataRepPrimType)(primTypeTag);
    if (primTypeTag === types_1.PrimType.Delayed)
        return false;
    if (primTypeTag === types_1.PrimType.List) {
        if (t.length < 2)
            return false;
        var elemsT = (0, isTaggedAsAlias_1.isTaggedAsAlias)(t[1]) ? (0, tyArgs_1.unwrapAlias)(t[1]) : t[1];
        if (elemsT[0] === types_1.PrimType.Pair) {
            return (isWellFormedDataRepType(elemsT[1]) &&
                isWellFormedDataRepType(elemsT[2]));
        }
        else
            return isWellFormedDataRepType(elemsT);
    }
    if (primTypeTag === types_1.PrimType.AsData ||
        // primTypeTag === PrimType.List      ||
        primTypeTag === types_1.PrimType.Alias)
        return t.length >= 2 && isWellFormedDataRepType(t[1]);
    if (primTypeTag === types_1.PrimType.Struct ||
        primTypeTag === types_1.PrimType.Sop) {
        return t.length >= 2 && (0, exports.isStructDefinition)(t[1]);
    }
    if (primTypeTag === types_1.PrimType.Pair) {
        return (isWellFormedDataRepType(t[1]) &&
            isWellFormedDataRepType(t[2]));
    }
    if (primTypeTag === types_1.PrimType.Lambda)
        return false;
    return false;
}
exports.isWellFormedDataRepType = isWellFormedDataRepType;
function isWellFormedGenericType(t) {
    if ((0, isTaggedAsAlias_1.isTaggedAsAlias)(t))
        return isWellFormedGenericType(t[1]);
    if (!(Array.isArray(t) &&
        t.length > 0))
        return false;
    if ((0, isTypePAram_1.isTypeParam)(t))
        return true;
    var primTypeTag = t[0];
    if (!((0, isPrimTypeTag_1.isPrimTypeTag)(primTypeTag)))
        return false;
    // just base type
    if (t.length === 1)
        return true;
    if (primTypeTag === types_1.PrimType.Delayed ||
        primTypeTag === types_1.PrimType.AsData ||
        primTypeTag === types_1.PrimType.List ||
        // ??
        primTypeTag === types_1.PrimType.Alias)
        return t.length >= 2 && isWellFormedGenericType(t[1]);
    if (primTypeTag === types_1.PrimType.Struct) {
        return t.length >= 2 && (0, exports.isGenericStructDefinition)(t[1]);
    }
    if (primTypeTag === types_1.PrimType.Sop) {
        return t.length >= 2 && (0, exports.isSopDefinition)(t[1]);
    }
    if (primTypeTag === types_1.PrimType.Lambda ||
        primTypeTag === types_1.PrimType.Pair) {
        var fst = isWellFormedGenericType(t[1]);
        var snd = isWellFormedGenericType(t[2]);
        if (!fst) {
            console.log("fst", (0, utils_1.termTypeToString)(t[1]));
        }
        if (!snd) {
            console.log("snd", (0, utils_1.termTypeToString)(t[2]));
        }
        return (t.length === 3 &&
            fst &&
            snd);
    }
    return false;
}
exports.isWellFormedGenericType = isWellFormedGenericType;
